var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-select",
    _vm._b(
      {
        attrs: {
          value: _vm.value,
          options: _vm.templates,
          "option-label": "name",
          "option-value": "id",
          label: _vm.label,
          loading: _vm.isLoading,
          "map-options": "",
          outlined: "",
        },
        on: {
          input: function ($event) {
            return _vm.$emit("change", $event)
          },
        },
      },
      "q-select",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }